import React, { Component } from 'react';
import ViewportProgress from '../../_core/components/ViewportProgress';
import Intro from '../_layouts/Intro';

class Com extends Component {

  tl = 0;
  els = [];

  constructor(props){

      super(props);
      this.state = {progress:0};
  }

  componentDidMount = () => {

      const _this = this;
      
      if(this.els.hasOwnProperty('logo')){

     

        this.tl = new window.TimelineMax({paused:true});

        // Setup
        this.tl.set(this.els['pink_1'],{scaleY:0,scaleX:0.02,transformOrigin:'100% 100%'});
        this.tl.set(this.els['pink_2'],{scaleY:0,transformOrigin:'0% 100%'});

        // Pink
        this.tl.to(this.els['pink_1'],0.7,{scaleY:1},0);
        this.tl.to(this.els['pink_1'],0.7,{scaleY:1,scaleX:1,transformOrigin:'100% 100%'},0.7);
        this.tl.to(this.els['pink_2'],1,{scaleY:1},1.5);

        // Lines In
        this.tl.fromTo(this.els['br_line'],3,{drawSVG:'0% 0%'},{drawSVG:'0% 100%'},0.5);
        this.tl.from(this.els['tl_line'],3,{drawSVG:'100% 100%'},1);

        // Blue
        this.tl.from(this.els['blue_1'],1,{scaleY:0,transformOrigin:'50% 0%'},1.7);
        this.tl.from(this.els['blue_2'],1,{scaleY:0,transformOrigin:'50% 0%'},1.7);

        // Yellow
        this.tl.from(this.els['yellow_1'],1,{scaleY:0,transformOrigin:'50% 100%'},1.7);
        this.tl.from(this.els['yellow_2'],1,{scaleY:0,transformOrigin:'50% 100%'},2);

        
        // Fade In the text
        this.tl.from(this.els['toptext'],1,{alpha:0},2.5);
        this.tl.from(this.els['bottomtext'],1,{alpha:0},2.5);

        // Fade In the logo
        this.tl.from(this.els['logo'],1.2,{alpha:0},2.5);


        this.tl.play();
      }
  }

  setRef = (label,el) => {

      this.els[label] = el;

  }

  render() {    

   

    return (
        
          <Intro setRef={this.setRef} />
    
    );
  }
}



export default Com;



// WEBPACK FOOTER //
// ./src/js/components/_interactions/InteractiveIntro.js